var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('floob-header',{attrs:{"title":'설정'}}),_c('floob-setting',{attrs:{"hideHeader":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }